
import { MapLocation } from '@/types/location';

// Ultimate Power GYM Locations
export const ultimatePowerGyms: MapLocation[] = [
  {
    id: 4001,
    name: "Ultimate Power GYM - Jeddah (Ar Rawdah)",
    type: "Gym",
    devices: 4,
    coordinates: [21.561069486122044, 39.15902691670423],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "18-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 4002,
    name: "Iron House - Riyadh (Al Aqiq)",
    type: "Gym",
    devices: 5,
    coordinates: [24.772322310409244, 46.6211842036944],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 4003,
    name: "Lionizer Cross - Riyadh (Al Malqa)",
    type: "Gym",
    devices: 3,
    coordinates: [24.83338185684165, 46.63620925646446],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "17-60",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 4004,
    name: "Amany Fitness - Jeddah (Sawary)",
    type: "Gym",
    devices: 3,
    coordinates: [21.796279615331994, 39.09061996249235],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-47",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 4005,
    name: "Time Movements - Jeddah (Al Marwa Female)",
    type: "Gym",
    devices: 3,
    coordinates: [21.621174076313164, 39.19783254662649],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "18-50",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 4006,
    name: "Time Movements - Jeddah (Al Marwa Male)",
    type: "Gym",
    devices: 3,
    coordinates: [21.62126384191656, 39.19884105714602],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "18-50",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 4007,
    name: "Time Movements - Jeddah (Al Hmdaiya Female)",
    type: "Gym",
    devices: 2,
    coordinates: [21.755543085993082, 39.18937207964693],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "18-50",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 4008,
    name: "Time Movements - Jeddah (Al Hmdaiya Male)",
    type: "Gym",
    devices: 2,
    coordinates: [21.754267603776132, 39.188685434186816],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "18-50",
    orientation: "Landscape",
    segment: "Fitness"
  }
];
